import {
  arbitrum,
  base,
  baseSepolia,
  mainnet,
  optimism,
  sepolia,
  zora,
  zoraSepolia,
} from '@ourzora/chains'
import { erc20Abi, zeroAddress } from 'viem'
import { cleanAddress } from '../../addresses'
import { ERC20Token, PoolAddressMap } from '../../types'

/**
 * A map of paired token symbols to network and their respective Uniswap v3 pool addresses.
 */
const UNISWAP_POOLS = {
  ['WETH']: {
    [mainnet.id]: cleanAddress('0x88e6A0c2dDD26FEEb64F039a2c41296FcB3f5640'),
    [sepolia.id]: cleanAddress(zeroAddress),
    [base.id]: cleanAddress('0xd0b53D9277642d899DF5C87A3966A349A798F224'),
    [baseSepolia.id]: cleanAddress(zeroAddress),
    [zora.id]: cleanAddress('0xbC59f8F3b275AA56A90D13bAE7cCe5e6e11A3b17'),
    [zoraSepolia.id]: cleanAddress(zeroAddress),
    [optimism.id]: cleanAddress('0x1fb3cf6e48F1E7B10213E7b6d87D4c073C7Fdb7b'),
    [arbitrum.id]: cleanAddress('0xC6962004f452bE9203591991D15f6b388e09E8D0'),
  },
  ['ZORA']: {
    [mainnet.id]: cleanAddress(zeroAddress),
    [sepolia.id]: cleanAddress(zeroAddress),
    [base.id]: cleanAddress('0xedc625b74537ee3a10874f53d170e9c17a906b9c'),
    [baseSepolia.id]: cleanAddress(zeroAddress),
    [zora.id]: cleanAddress(zeroAddress),
    [zoraSepolia.id]: cleanAddress(zeroAddress),
    [optimism.id]: cleanAddress(zeroAddress),
    [arbitrum.id]: cleanAddress(zeroAddress),
  },
} as const satisfies PoolAddressMap

/**
 * USDC contract info
 *
 * Contains static token information, the ERC20 abi, a map contract addresses
 * by network and a map of relevant Uniswap V3 pool addresses.
 */
export const USDC = {
  abi: erc20Abi,
  address: {
    [mainnet.id]: cleanAddress('0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'),
    [sepolia.id]: cleanAddress('0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238'),
    [base.id]: cleanAddress('0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913'),
    [baseSepolia.id]: cleanAddress('0x036CbD53842c5426634e7929541eC2318f3dCF7e'),
    [zora.id]: cleanAddress('0xCccCCccc7021b32EBb4e8C08314bD62F7c653EC4'),
    [zoraSepolia.id]: cleanAddress('0xccCcCc4532d20C06726866e328F7478Edabf907B'),
    [optimism.id]: cleanAddress('0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85'),
    [arbitrum.id]: cleanAddress('0xaf88d065e77c8cC2239327C5EDb3A432268e5831'),
  },
  poolAddress: UNISWAP_POOLS,
  name: 'USD Coin',
  symbol: 'USDC',
  decimals: 6,
} as const satisfies ERC20Token
